export const _SUCCESS = "_SUCCESS";
export const _FAILURE = "_FAILURE";
export const FETCH_ASSESSMENTS_REQUEST = "FETCH_ASSESSMENTS_REQUEST";
export const CREATE_ASSESSMENTS_REQUEST = "CREATE_ASSESSMENTS_REQUEST";
